module.exports = __webpack_public_path__ + "img/The_Beacon.6d2b80a6.jpg";